<div class="accordion-container">
  @for (groupedFile of reportFiles; track groupedFile) {
    <div class="accordion-item">
      <div class="accordion-header" (click)="toggle(groupedFile.date)">
        <span>{{ groupedFile.date }}</span>
        <span class="arrow open" [ngClass]="{'close': active[groupedFile.date]}"></span>
      </div>
      <div class="accordion-body" [ngClass]="{'active': active[groupedFile.date]}">
        @for (file of groupedFile.values; track file) {
          <div class="accordion-body-content">
            <div class="panel-body">
              <p style="color: #333333; font-size: 16px; font-family: 'HelveticaNeue'" class="mb-3">
                <a href={{file.link}} (click)="file.click ? file.click() : true">{{file.reportType}} - {{file.date | date}}</a>
              </p>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>